<template>
    <div>
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
            <el-form-item label="Secret Key" prop="aesKey">
                <el-input v-model="dataForm.aesKey" placeholder="Aes Key"></el-input>
            </el-form-item>
            <el-form-item label="AppId" prop="issueId">
                <el-input v-model="dataForm.issueId" placeholder="账号issueId,请输入6位正整数" minlength="6" maxlength="6"></el-input>
            </el-form-item>
            <!-- <el-form-item label="Secret Key" prop="secretKey">
                <el-input v-model="dataForm.secretKey" placeholder="Secret Key"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="ilabx项目地址" prop="ilabUrl">
                <el-input v-model="dataForm.ilabUrl" placeholder="ilabx项目地址"></el-input>
            </el-form-item> -->
        </el-form>
        <div style="text-align:right">
            <el-button @click="$emit('close')">取消</el-button>
            <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
        </div>
    </div>

    
</template>

<script>
import { add ,update , getApiInfoEntity } from "@/api/shenbao/shenbao-api"
  export default {
    props:{
        shenbaoId:{
            type:String,
            default: ''
        }
    },
    watch:{
        shenbaoId: {
            immediate:true,
            handler: function(newVal) {
                if(newVal)  this.getInfoApiEntity(newVal)
            }
        }
    },
    data () {
      return {
        visible: false,
        dataForm:{},
        dataRule: {
          // secretKey: [
          //   { required: true, message: '不能为空', trigger: 'blur' }
          // ],
          aesKey: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          issueId: [
            { required: true, message: '请输入6位正整数,且不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      handClose(){  //弹窗关闭时清除filelist
          this.$emit('close')
      },
      getInfoApiEntity(id){      //通过ID获取API弹窗信息
        getApiInfoEntity(id).then(res=>{
            this.dataForm = res || { shenbaoId: id }

        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
                let opFun = this.dataForm.id ? update : add;
                opFun(this.dataForm).then(()=>{
                    this.$emit('close')
                    this.$message.success("操作成功");
                })
            }else return false;
        })
      }
    }
  }
</script>
